import { render, staticRenderFns } from "./configsearch.vue?vue&type=template&id=a3f69d22&scoped=true&"
import script from "./configsearch.vue?vue&type=script&lang=js&"
export * from "./configsearch.vue?vue&type=script&lang=js&"
import style0 from "./configsearch.vue?vue&type=style&index=0&id=a3f69d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f69d22",
  null
  
)

export default component.exports